import { Shell } from '@/components/layout/shell'
import { GlobalErrorFallback } from '@/components/system/global-error-fallback'
import { requireAuth } from '@/features/auth/guards/require-auth'
import { projectQuery } from '@/features/projects/queries/projects-query'
import { messages } from '@/lib/i18n/messages'
import { Outlet, createFileRoute } from '@tanstack/react-router'
import * as z from 'zod'

const paramsSchema = z.object({
  projectId: z.coerce.number().int().positive(),
})

export const Route = createFileRoute('/projects/$projectId/_layout')({
  parseParams: paramsSchema.parse,
  stringifyParams: ({ projectId }) => ({ projectId: String(projectId) }),
  beforeLoad: requireAuth,
  loader: async ({ params, context }) =>
    context.queryClient.ensureQueryData(projectQuery(params.projectId)),
  staticData: {
    crumbParent: { label: messages.crumbs.projects, to: '/projects/' },
    crumb: (m: { loaderData?: { code: string; name: string } }) =>
      m.loaderData ? `${m.loaderData.code} ${m.loaderData.name}` : messages.projects.fallback,
  },
  errorComponent: GlobalErrorFallback,
  component: ProjectScopedLayout,
})

function ProjectScopedLayout() {
  const { projectId } = Route.useParams()
  return (
    <Shell activeProjectId={projectId}>
      <Outlet />
    </Shell>
  )
}
